/** 選手の名簿（docs/01_game-design.md 9 章）。すべて架空の人物 */
export interface Stats {
  physical: number;
  mental: number;
  luck: number;
  glider: number;
  run: number;
}

/** CPU の性格（docs/03_simulation.md 11 章） */
export interface Personality {
  riskAversion: number;
  peakBias: number;
  hikeBias: number;
  stormCaution: number;
  staminaReserve: number;
  autoStyle: 'attack' | 'defend';
  /** バランス確認用：離陸地の種類を固定する（'none' は飛ばない） */
  forceTier?: 'none' | 'low' | 'ridge' | 'peak';
}

export interface AthleteSetup {
  id: string;
  name: string;
  country: string;
  color: string;
  stats: Stats;
  personality: Personality;
  isPlayer: boolean;
  /** 性格の一言（ライバル紹介用） */
  blurb: string;
}

const BALANCED: Personality = {
  riskAversion: 0.5,
  peakBias: 0,
  hikeBias: 0,
  stormCaution: 0.6,
  staminaReserve: 25,
  autoStyle: 'defend',
};

export const PLAYER_DEFAULT: AthleteSetup = {
  id: 'player',
  name: 'YOU',
  country: 'JPN',
  color: '#22d3ee',
  stats: { physical: 6, mental: 6, luck: 6, glider: 6, run: 6 },
  personality: BALANCED,
  isPlayer: true,
  blurb: 'あなた',
};

export const RIVALS: AthleteSetup[] = [
  {
    id: 'heim',
    name: 'クラウス・ハイム',
    country: 'AUT',
    color: '#f97316',
    stats: { physical: 9, mental: 6, luck: 4, glider: 3, run: 8 },
    personality: { ...BALANCED, hikeBias: 0.8, peakBias: -0.3, riskAversion: 0.6 },
    isPlayer: false,
    blurb: '脚の鬼。歩いて稼ぐ',
  },
  {
    id: 'roche',
    name: 'エミリー・ロシェ',
    country: 'FRA',
    color: '#a78bfa',
    stats: { physical: 5, mental: 6, luck: 5, glider: 9, run: 5 },
    personality: { ...BALANCED, hikeBias: -0.6, peakBias: 0.2, autoStyle: 'attack' },
    isPlayer: false,
    blurb: '空の職人。飛べる日は必ず飛ぶ',
  },
  {
    id: 'ferran',
    name: 'ダリオ・フェラン',
    country: 'ITA',
    color: '#ef4444',
    stats: { physical: 6, mental: 3, luck: 9, glider: 6, run: 6 },
    personality: { ...BALANCED, peakBias: 0.9, riskAversion: 0.1, stormCaution: 0.2, autoStyle: 'attack' },
    isPlayer: false,
    blurb: 'ギャンブラー。ピークハントが好き',
  },
  {
    id: 'saeki',
    name: '佐伯 蒼',
    country: 'JPN',
    color: '#22c55e',
    stats: { physical: 6, mental: 9, luck: 5, glider: 6, run: 4 },
    personality: { ...BALANCED, riskAversion: 0.8, stormCaution: 1.0 },
    isPlayer: false,
    blurb: '堅実派。雷雨のサインに敏感',
  },
  {
    id: 'bruhl',
    name: 'ヨナス・ブリュール',
    country: 'SUI',
    color: '#eab308',
    stats: { physical: 7, mental: 6, luck: 5, glider: 7, run: 5 },
    personality: { ...BALANCED, riskAversion: 0.3, peakBias: 0.3, autoStyle: 'attack' },
    isPlayer: false,
    blurb: '天才肌。攻めの判断',
  },
];
